import axios from 'axios';
import Swal from 'sweetalert2';
import authService from './auth';
import { isPrivatePath } from 'src/routes/privatePaths';

let baseURL = process.env.REACT_APP_NODE_ENV;

const instance = axios.create({ baseURL });

function handleUnauthorized() {
  const isPrivate = isPrivatePath(window.location.pathname);
  console.log('isPrivate', isPrivate);
  authService.clearSession();
  Swal.fire({
    title: 'Sesión expirada',
    confirmButtonText: 'Ir a iniciar sesión',
    ...(isPrivate
      ? {
          text: 'Tu sesión ha expirado. Debes volver a iniciar sesión.',
        }
      : {
          text: 'Tu sesión ha expirado. Puedes cerrar este mensaje y seguir navegando, o ir a iniciar sesión.',
          showCancelButton: true,
          cancelButtonText: 'Cerrar',
        }),
  }).then((result) => {
    if (result.value || isPrivate) {
      window.location.replace('/login');
    }
  });
}

instance.interceptors.request.use(
  function onIntercept(config) {
    const token = authService.getSession();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function onError(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function onIntercept(response) {
    return response;
  },
  function onError(error) {
    if (error.response?.status === 401) {
      handleUnauthorized();
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;
